<template>
    <div class="bl_p_count">
        <input type="text" :readonly="readonly" @blur="setQuantity($event.target.value)" @keyup.enter="setQuantity($event.target.value)" :value="quan" >
        <span v-show="!hideControls" @click="setQuantity(+quan - +step)" class="btn_ico_minus"></span>
        <span v-show="!hideControls" @click="setQuantity(+quan + +step)" class="btn_ico_plus"></span>
    </div>
</template>

<script>
export default {
    name: 'Quantity',
    model: {
        prop: 'quantity',
    },
	props : {
    hideControls : {
            type : Boolean,
            default : false,
        },
		quantity : {
            type : Number,
            default : 1,
        },
		minQuantity : {
            type : Number,
            default : 1,
        },
		step : {
            type : Number,
            default : 1,
        },
		maxQuantity : {
            type : Number,
            default : 9999,
        },
		readonly : {
            type : Boolean,
            default : false,
        },
    productId : Number,
	},
    data : () => ({
        quan : 1,
    }),
    mounted () {
        this.quan =  this.quantity;
    },
    watch : {
        quantity (val, oldVal) {
            this.quan =  this.quantity;
        },
    },
    methods : {
        setQuantity (quantity) {

            if(quantity <= 0){
              if(this.$parent.$options._componentTag=="basketline"){
                this.$parent.deleteToProductInCart(this);
              }else
                {
                  this.$parent.deleteToProductInCart();
                }
            }

            if (quantity < this.minQuantity) {
                quantity = this.minQuantity;
            }
            if (quantity > this.maxQuantity) {
                quantity = this.maxQuantity;
                showHeaderMessage('Достигнуто предельное количество', 'at_error');
            }
            this.$emit('input', quantity);
            this.$emit('quantity:changed', this.productId, quantity);
            this.$emit('change');

            if (typeof(this.$parent.quantity) != 'undefined') {
                this.$parent.quantity = quantity;
                if (quantity >= this.maxQuantity) {
                    this.$parent.isQuantityLimit = true;
                }
                else if (this.$parent.isQuantityLimit) {
                    this.$parent.isQuantityLimit = false;
                }
            }
            /*if(this.$parent.$options._componentTag=="basketline" && quantity > 0){
              this.quan = quantity;
              this.$parent.addToCart(this);
            }*/

        },
    },
}
</script>
